import '../../style/root/navigation.css'

import Badge from '@material-ui/core/Badge'
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import ApartmentIcon from '@material-ui/icons/Apartment'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined'
import AddBusinessIcon from '@mui/icons-material/AddBusiness'
import EngineeringIcon from '@mui/icons-material/Engineering'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'

import { isAdminOrSuper } from '../../utils/helpers/isAdminOrSuper'
import { TUser } from '../../utils/types'
import { SideNavLink } from '../root/SideNavLink'

interface AdminSideNavBarProps {
  user: TUser
  pathname: string | null
  toggleFunction?: () => void
  invoicesCount: number
}

export const AdminSideNavBar = ({
  user,
  pathname,
  toggleFunction,
  invoicesCount,
}: AdminSideNavBarProps) => {
  const isActive = (path: string) => !!pathname?.startsWith(path)

  return (
    <div
      className="nav-list beam-navigation--admin"
      onClick={toggleFunction}
      onKeyDown={toggleFunction}>
      <SideNavLink path="/admin/partners/all" active={isActive('/admin/partners')}>
        <AccountBoxOutlinedIcon />
        <div>Our Partners</div>
      </SideNavLink>
      {isAdminOrSuper(user?.type) && (
        <SideNavLink path="/admin/nonprofits/all" active={isActive('/admin/nonprofits')}>
          <ApartmentIcon />
          <div>Our Nonprofits</div>
        </SideNavLink>
      )}
      <SideNavLink path="/admin/invoices" active={isActive('/admin/invoices')}>
        <ReceiptOutlinedIcon />
        <div>Invoices</div>
        <Badge
          overlap="rectangular"
          badgeContent={invoicesCount}
          color="secondary"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}>
          <div style={{ height: '16px', width: '20px' }} />
        </Badge>
      </SideNavLink>
      <SideNavLink path="/profile" active={isActive('/profile')}>
        <AccountCircleOutlinedIcon />
        <div>{user && user.firstName}</div>
      </SideNavLink>
      {isAdminOrSuper(user?.type) && (
        <SideNavLink path="/admin/apikeys" active={isActive('/admin/apikeys')}>
          <EngineeringIcon />
          <div>Api Keys</div>
        </SideNavLink>
      )}
      {isAdminOrSuper(user?.type) && (
        <SideNavLink path="/admin/createuser" active={isActive('/admin/createuser')}>
          <PersonAddAlt1Icon />
          <div>Create User</div>
        </SideNavLink>
      )}
      {isAdminOrSuper(user?.type) && (
        <SideNavLink path="/admin/createpartner" active={isActive('/admin/createpartner')}>
          <AddBusinessIcon />
          <div>Add Partner</div>
        </SideNavLink>
      )}
      <SideNavLink path="/logout" active={isActive('/logout')}>
        <ExitToAppOutlinedIcon />
        <div>Log out</div>
      </SideNavLink>
    </div>
  )
}
